export const getBloodstoneAddress = () => {
  return "0x784D67FB2DEF7055650D6D72A400CA01Cb8e408B";// ya esta 1 2 3 ok ok
};

export const getBeastAddress = () => {
  return "0xa4BA31bcFf83e8F9ea8C447D23e153a7C06D02A8"; // ya esta 1 2 3 OK
};

export const getWarriorAddress = () => {
  return "0x6DA2055bfa4d3AecD53b12b20DC1744b42754A40"; // ya esta 1 2 3 OK
};

export const getLegionAddress = () => {
  return "0x18c2ff06605f9dc24cf284e0b9cff35b2ad608df"; // ya esta 1 2 3 OK
};

export const getMonsterAddress = () => {
  return "0x8d2d8185Bd4DC85B887b9a1BA5f2eADfDb907477"; // ya esta 1 2 3 OK
};

export const getRewardPoolAddress = () => {
  return "0x6cAFB1104EbA56B7B5098c70B85375B6366d98B1";// ya esta 1 2 3 OK
};

export const getMarketplaceAddress = () => {
  return "0x3a5bD71e680A56A6aD7077C6134cf8A1b89a18aF"; // ya esta 1 2 3 OK
};

export const getFeeHandlerAddress = () => {
  return "0xacBD142D7d9B539fb1469fF44691D16162bf6e58"; // ya esta 1 2 3 OK
};
// Original https://kovan.etherscan.io/token/0x023a368a269c60fb7701b7e20cb3bf46eed508bc#code
